/**
 * Formats a BRL amount the pt-BR way: "R$ 1234,56".
 *
 * The panel had two conventions living side by side — /painel built
 * `R$ ${v.toFixed(2).replace(".", ",")}` inline (twice, duplicated), while
 * /anuncios/radio and /anuncios/tv rendered `R${v.toFixed(2)}`, producing the
 * US-looking "R$0.00". This is the single shared implementation.
 *
 * The separator is applied explicitly rather than via toLocaleString("pt-BR")
 * so the output does not depend on which ICU locale data the runtime ships —
 * jsdom and some slim Node builds fall back to en-US and would silently emit
 * a decimal point again.
 */
export function formatCurrencyBRL(value: number): string {
  const sign = value < 0 ? "-" : "";
  const absolute = Math.abs(value);
  return `${sign}R$ ${absolute.toFixed(2).replace(".", ",")}`;
}

export default formatCurrencyBRL;
